const schema = {
  type: 'Object',
  contents: {
    _id: { type: 'ObjectId' },
    src: { type: 'DBRef', label: '銷售來源' },
    meta: {
      type: 'Object',
      contents: {
        note: { type: 'String', label: '內部備註' },
      },
    },
    invoice: {
      // TODO rename to twInvoice or twEInvoice
      type: 'Object',
    },

    // WHAT WAS ASKED FOR, kept so that whatever retries the row can send the
    // same thing. Rebuilding it from the order instead would mean an edit
    // between the first attempt and a later one quietly changes the invoice --
    // and the customer was handed a total at the counter, not whatever the
    // order says an hour later.
    //
    // Untyped for the same reason `invoice` is: it is the service's shape, not
    // ours, and this stores it rather than interpreting it.
    request: {
      type: 'Object',
    },

    // WHEN TO TRY AGAIN, and when to stop. Together these are the whole state
    // of a row that has no invoice yet -- there is no status field, and
    // deliberately so: `invoice` already says whether one exists, and a second
    // field saying the same thing is a second field that can disagree.
    // pos/retailOrder/db/awards.js runs on the same two dates for the same
    // reason.
    //
    // A row with neither field is one written before any of this existed. Every
    // query below is a date comparison, and mongo's are type-bracketed, so
    // those rows are invisible to the retrying and stay exactly where they are
    // -- which is right. They are months old, far past any window in which
    // issuing would be an ordinary act, and `npm run reconcile` is what settles
    // them. Nothing had to be backfilled to make that true.
    //
    // LABELLED, because the issuer list shows both. coact's buildFieldProps
    // falls back to `label || name || path.join('.')`, so without these two the
    // column headers read as English paths among the Chinese ones.
    nextAttemptAt: { type: 'Date', label: '下次重試時間' },
    deadlineAt: { type: 'Date', label: '重試截止時間' },

    // What each attempt ran into. The material a 說明 gets written from if the
    // invoice ends up being issued late, so it outlives the attempt itself.
    attempts: {
      type: 'Array',
      contents: [
        {
          type: 'Object',
          contents: {
            at: { type: 'Date' },
            code: { type: 'String' },
            message: { type: 'String' },
          },
        },
      ],
    },
  },
}

export default schema
